<script setup>
const shareLinkedIn = () => {
  const url =
    'https://www.linkedin.com/sharing/share-offsite/?url=' +
    encodeURIComponent(window.location.href)
  openSharingWindow(url)
}

const shareFacebook = () => {
  const url =
    'https://www.facebook.com/sharer/sharer.php?u=' +
    encodeURIComponent(window.location.href)
  openSharingWindow(url)
}

const shareTwitter = () => {
  const url =
    'https://twitter.com/intent/tweet?url=' +
    encodeURIComponent(window.location.href)
  openSharingWindow(url)
}

const openSharingWindow = (url) => {
  const width = 500
  const height = 400
  const left = window.screen.width / 2 - width / 2
  const top = window.screen.height / 2 - height / 2

  const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`

  window.open(url, 'socialSharing', features)
}
</script>

<template>
  <div>
    <ul class="share-list">
      <li class="share-item animate-stagger-item">
        <div
          class="btn btn--round btn--round-dark sensible"
          @click="shareLinkedIn">
          <svg class="icon icon--btn-round">
            <use xlink:href="#icon-social-linkedin"></use>
          </svg>
        </div>
      </li>
      <li class="share-item animate-stagger-item">
        <div
          class="btn btn--round btn--round-dark sensible"
          @click="shareFacebook">
          <svg class="icon icon--btn-round">
            <use xlink:href="#icon-social-facebook"></use>
          </svg>
        </div>
      </li>
      <li class="share-item animate-stagger-item">
        <div
          class="btn btn--round btn--round-dark sensible"
          @click="shareTwitter">
          <svg class="icon icon--btn-round">
            <use xlink:href="#icon-social-twitter"></use>
          </svg>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.share-list {
  @include list-reset;
  margin-bottom: pxrem(35);

  @include mq(md) {
    margin-bottom: pxrem(50);
  }
}

.share-item {
  display: inline-block;
  margin-right: pxrem(8);

  &:last-of-type {
    margin-right: 0;
  }
}
</style>
